import styled from "styled-components/macro";

// export const confirmModalStyles =  {
//   content: {
//     top: "50%",
//     left: "50%",
//     right: "auto",
//     bottom: "auto",
//     marginRight: "-50%",
//     zIndex: "30000",
//     width: "250px",
//     height: "auto",
//     maxHeight: "660px",
//     transform: "translate(-50%, -50%)",
//     border: "none",
//     borderRadius: "20px",
//     boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.10), 0px 0px 2px 0px rgba(0, 0, 0, 0.25)",
//     padding: "24px 16px",
//     paddingBottom: "0",
//     overflow: "hidden",
//     backgroundColor: "var(--menu-color)",
//   },
//   overlay: {
//     backgroundColor: "rgba(0, 0, 0, 0.6)",
//   },
// };

export const ConfirmModalWrapper = styled.div`
  width: ${({ $modalWidth }) => $modalWidth || "250px"};
  height: auto;
  max-height: 660px;
  overflow: hidden;
  transform: translate(-50%, -50%);
  border: none;
  border-radius: 20px;
  box-shadow: var(--default-drop-shadow);
  background-color: var(--menu-color);
`;

export const ConfirmModalContent = styled.div`
  font-family: "Inter", Helvetica, sans-serif;
  text-align: left;
  font-weight: 500;

  .content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    line-height: normal;
    padding: 17px 16px;
    padding-bottom: 0;
    color: var(--grey-0);

    .title {
      font-weight: 600;
      line-height: 1.4em !important;
    }

    p {
      line-height: 1.4em !important;
    }
  }

  .action-bar {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    gap: 6px;
    box-sizing: border-box;
    padding: 8px 12px;
    padding-bottom: 12px;

    .action-confirm {
      .text-button-inner {
        color: var(--danger-color);
      }
    }
  }
`;
